/**
 * Garden Style Carousel - Hotspot functionality
 * Handles hotspot click/touch interactions and popup display
 */
(function () {
  function initGardenStyleCarousel() {
    const sections = document.querySelectorAll('.garden-style');

    sections.forEach(function (section) {
      const hotspots = section.querySelectorAll('.garden-style__hotspot');

      // Handle hotspot interactions
      hotspots.forEach(function (hotspot) {
        function handleInteraction(event) {
          // Don't prevent default if clicking the popup link
          if (event.target.closest('.garden-style__popup')) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          const isOpen = hotspot.classList.contains('open');

          // Close all hotspots in this section
          hotspots.forEach(function (hs) {
            hs.classList.remove('open');
          });

          // If it wasn't open, open it now
          if (!isOpen) {
            hotspot.classList.add('open');
          }
        }

        hotspot.addEventListener('click', handleInteraction);

        // Prevent default touch behaviors that might interfere
        hotspot.addEventListener(
          'touchend',
          function (event) {
            // Allow popup link clicks
            if (event.target.closest('.garden-style__popup')) {
              return;
            }
            event.preventDefault();
            handleInteraction(event);
          },
          { passive: false }
        );
      });
    });

    // Close popups when clicking/tapping outside
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.garden-style__hotspot')) {
        closeAllPopups();
      }
    });
  }

  function closeAllPopups() {
    document.querySelectorAll('.garden-style__hotspot.open').forEach(function (hs) {
      hs.classList.remove('open');
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGardenStyleCarousel);
  } else {
    initGardenStyleCarousel();
  }

  // Re-initialize when Splide is ready (for dynamically loaded content)
  document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.js-garden-style-carousel');
    sliders.forEach(function (slider) {
      const observer = new MutationObserver(function () {
        initGardenStyleCarousel();
      });
      observer.observe(slider, { attributes: true, attributeFilter: ['style'] });
    });
  });
})();
